module.exports = __webpack_public_path__ + "img/gallery-icon.4885e39.svg";